/**
 * Shared Ant Design Tag colors for PMP task metadata.
 * Keep distinct from priority, mandatory (green), shutdown (red), and trigger (purple) tags.
 * Parts use `default` — muted secondary/metadata chip (same pattern as partners, asset fields).
 */
export const PMP_TAG_COLOR = {
  workType: 'blue',
  part: 'default',
} as const;
